import axios from 'axios'
import i18n from 'i18n'
import { toast } from 'react-toastify'
import { BASE_URL } from 'services'

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Access-Control-Allow-Origin': '*',
    // 'X-Client-Org-Mode': 'true',
  },
  //   withCredentials: true,
})

axiosInstance.interceptors.request.use(
  (config: any) => {
    return config
  },
  (error: any) => {
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.response.use(
  (response: any) => {
    return response.data
  },
  (error: any) => {
    if (error.response.status === 499) {
      const redirectUrl = error.response.data.headers.location
      window.location.href = redirectUrl
      return
    }
    toast.error(i18n.t('failedToCreate'))
    return Promise.reject(error)
  }
)

export default axiosInstance
